import { Link } from "gatsby"
import { FC } from "react"
import {
  subtopicsSectionWrapper,
  header,
  articleLink,
  firstCategory
} from "./Subtopics.module.scss"
import classNames from "classnames"

// utils
import { handleUrlString } from "../../utils/seo/seo_utils"

export type singleArticle =
  Queries.CategoriesQuery["contentfulCategoryMenu"]["subcategories"][0]["articleList"][0]

export type Props = {
  subcategoryHeader: string
  articleList: singleArticle[]
  prefixedBasePath: string
  index?: number
}

const Subtopic: FC<Props> = ({
  subcategoryHeader,
  articleList,
  index,
  prefixedBasePath
}) => {
  return (
    <div className={subtopicsSectionWrapper}>
      <h3 className={classNames(header, { [`${firstCategory}`]: index === 0 })}>
        {subcategoryHeader}
      </h3>
      <ul>
        {articleList?.map((art) => {
          const linkUrl = art?.articleId
            ? `/articles/${art.articleId}/${art.slug}`
            : `/articles/${art.slug}`

          return (
            <li className={articleLink} key={art.slug}>
              {" "}
              <Link
                to={handleUrlString(`${prefixedBasePath}/${linkUrl}/`, {
                  removePrefix: true
                })}
              >
                {art.title}
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Subtopic
